module.exports = __webpack_public_path__ + "img/65.b607f06d.jpg";